import type BookingService from 'owa-service/lib/contract/BookingService';
import createMeetingTypeExtension from '../services/createMeetingTypeExtension';
import type MeetingTypeExtension from '../services/schema/MeetingTypeExtension';
import BookingPrivacyType from '../store/schema/BookingPrivacyType';
import type SchedulingPolicyBooking from '../store/schema/SchedulingPolicyBooking';
import getMeetingTypeExtensionSchedulingPolicy from './getMeetingTypeExtensionSchedulingPolicy';
import { parseMeetingTypeDescription } from './parseServiceDescription';
import { logUsage } from 'owa-analytics';
import { UserOnboardingState } from '../store/schema/BookWithMeOrganizerStore';
import setUserOnboardingState from '../actions/setUserOnboardingState';

const getMeetingTypeExtensionRequestBody = (defaultService: BookingService) => {
    const {
        Description = '',
        AdditionalInformation,
        DefaultDurationMinutes,
        IsDefaultLocationOnline,
        PreBuffer,
        PostBuffer,
        ExcludeFromSelfService,
    } = defaultService;
    const serviceDescription = parseMeetingTypeDescription(Description);
    const isPrivate = serviceDescription.privacyType === BookingPrivacyType.PrivateMeetingType;
    const schedulingPolicyMeetingTypeExtension: SchedulingPolicyBooking =
        getMeetingTypeExtensionSchedulingPolicy(defaultService);
    const meetingTypeExtensionRequestBody: MeetingTypeExtension = {
        itemId: defaultService.ServiceId ?? '',
        displayName: defaultService.DisplayName ?? '',
        isPrivate,
        recipients: [],
        description: Description,
        additionalInformation: AdditionalInformation,
        schedulingPolicy: schedulingPolicyMeetingTypeExtension,
        durationMinutes: DefaultDurationMinutes,
        isDefaultLocationOnline: IsDefaultLocationOnline,
        preBuffer: PreBuffer,
        postBuffer: PostBuffer,
        excludeFromSelfService: ExcludeFromSelfService,
    };
    return meetingTypeExtensionRequestBody;
};

const createDefaultMeetingTypeExtenstion = async (defaultService?: BookingService) => {
    if (defaultService) {
        const meetingTypeExtensionBody = getMeetingTypeExtensionRequestBody(defaultService);
        try {
            const response = await createMeetingTypeExtension(meetingTypeExtensionBody);
            if (response) {
                setUserOnboardingState(UserOnboardingState.UserFirstSessionDefaulServiceCreated);
                logUsage('onDefaultServiceCreation');
            } else {
                logUsage('onDefaultServiceCreationFailed');
            }
        } catch {
            logUsage('onDefaultServiceCreationFailed');
        }
    }
};

export default createDefaultMeetingTypeExtenstion;
